import formatResponseErrors from './helpers/formatResponseErrors';
export default {
    /**
     * Sets flash message
     * @param {Object} ctx - Context set by vuex (store)
     * @param {String|Array} payload - Message
     */
    setFlash(ctx, { message, key }) {
        if (message == null) return;

        const flashKey = key || 'error';
        let flash = message;

        // If we have an array of messages, build up an unordered list as a string
        if (message.constructor === Array) {
            flash = '<ul>';
            for (var i = 0; i < message.length; i++) {
                flash += '<li>' + message[i] + '</li>';
            }
            flash += '</ul>';
        }

        // Generate a ul of object values
        if (message.constructor === Object) {
            flash = '<ul>';
            Object.values(message).forEach(val => {
                flash += `<li>${val}</li>`;
            });
            flash += '</ul>';
        }

        ctx.commit('setFlash', { flash, flashKey });
    },

    /**
     * Formats and sets flash message
     * @param {Object} ctx - Context set by vuex (store)
     * @param {String|Array} payload - Error object
     */
    formatAndSetFlash(ctx, { message, key }) {
        ctx.dispatch('setFlash', {
            message:
                typeof message == 'string'
                    ? message
                    : formatResponseErrors(message),
            key
        });
    },

    /**
     * Clears current flash
     * @param {Object} ctx - Context set by vuex (store)
     */
    clearFlash(ctx) {
        ctx.commit('clearFlash');
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Flash/actions.js